export default __webpack_public_path__ + "static/media/Task tracker.ebab0743.jpg";